import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Stamp, Building2 } from "lucide-react";
import { PlaceHolderImages } from "../lib/placeholder-images";

export const CompanyProfile: React.FC = () => {
  const companyImage = PlaceHolderImages.find((p) => p.id === "company-profile-image");
  const groupImage = PlaceHolderImages.find((p) => p.id === "group-profile-image");

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Company Profile Card */}
      <Card className="border-gray-200  bg-white rounded-xl overflow-hidden gsap-wwa-profile-card">
        {companyImage && (
          <div className="relative h-64 w-full">
            <img
              src={companyImage.imageUrl}
              alt={companyImage.description}
              className="object-cover w-full h-full"
              data-ai-hint={companyImage.imageHint}
            />
          </div>
        )}
        <CardHeader>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
              <Stamp className="w-8 h-8" />
            </div>
            <CardTitle className="text-2xl text-primary">Company Profile</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4 text-muted-foreground pt-0">
          <p>
            A proud subsidiary of the reputable E.S.S. Group, Dubai, UBER Travel agency is a fast,
            secure and tech-driven visa solutions provider offering hassle-free processing for
            tourist, visit and business visas.
          </p>
          <p>
            With a client-first approach and streamlined digital systems, we simplify travel
            documentation – making global mobility smarter, faster and easier for individuals and
            businesses alike.
          </p>
        </CardContent>
      </Card>

      {/* Group Profile Card */}
      <Card className="border-gray-200  bg-white rounded-xl overflow-hidden gsap-wwa-profile-card">
        {groupImage && (
          <div className="relative h-64 w-full">
            <img
              src={groupImage.imageUrl}
              alt={groupImage.description}
              className="object-cover w-full h-full"
              data-ai-hint={groupImage.imageHint}
            />
          </div>
        )}
        <CardHeader>
          <div className="flex items-center gap-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary flex-shrink-0">
              <Building2 className="w-8 h-8" />
            </div>
            <CardTitle className="text-2xl text-primary">Group Profile</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4 text-muted-foreground pt-0">
          <p>
            Driving excellence under the ESS Group legacy. With a multi-dimensional business
            philosophy, ESS GROUP has strategically expanded its footprint across key industries –
            ranging from Government and PRO services to Real Estate and Interior Solutions. Each
            division under the group is driven by a shared vision: to deliver value, innovation, and
            trust through every venture.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};
